import { ArrowLeftOutlined, DeleteOutlined, EditOutlined} from "@ant-design/icons";
import { Button,notification } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {CalendarIcon} from "@radix-ui/react-icons";


// Components
import { DashboardWrapper } from "../../components/DashboardWrapper/DashboardWrapper.styles";

import { getPatient, getSurveyToken } from "../../utils/api-lists/patient.api";
import { getRecentVisits } from "../../utils/api-lists/visit.api";
import PatientInfoHeader from "./components/PatientInfoHeader";
import PatientTreatmentSteps from "./components/PatientTreatmentSteps";
import ReportTable from "./components/ReportTable";
import VisitsHistory from "./components/VisitsHistory";
import WrinklesBanner from "./components/WrinklesBanner";
import { UserContext } from "../../context/UserContext";

const PatientsCabinetPage = () => {
    const {patientId} = useParams();
    const navigate = useNavigate();
    const {t} = useTranslation("common");
    const {user} = useContext(UserContext);


    const [isSurveyRequested, setIsSurveyRequested] = useState(false);
    const [patient, setPatient] = useState(null);
    const [visits, setVisits] = useState([]);
    const [error, setError] = useState(null);
    const [alert, setAlert] = useState({message: "", type: ""});
    const patientInfoRef = React.useRef();

    const fetchPatient = async () => {
        try {
            const patientPayload = await getPatient(patientId);
            setPatient(patientPayload);

            const visitsPayload = await getRecentVisits(patientId);
            setVisits(visitsPayload);
        } catch (err) {
            setError(err.message);
        }
    };

    useEffect(() => {
        fetchPatient();
    }, [patientId]);

        const handleCopyLink = async () => {
            try {
                const token = await getSurveyToken(patientId, user.id);
                const path = `/create-survey?patientId=${patientId}&doctorId=${user.id}&token=${token}`;
                notification.success({
                    placement: "top",
                    message: t("survey_email_sent_success"),
                    description: t("survey_email_sent_description"),
                    duration: 4,
                });
    
                setIsSurveyRequested(true);
    
            } catch (error) {
                console.error("Error copying link:", error);
                notification.error({
                    placement: "top",
                    message: t("survey_email_send_error"),
                    description: t("survey_email_send_error_description"),
                    duration: 4,
                });
            }
        };

    return (
      <DashboardWrapper>
        {/*<DashboardHeader />*/}

        <div className="flex gap-4 flex-col mb-4">
          {patient && (
            <div>
              {/* Top Action Bar */}
              <div className="flex justify-between items-center mb-4">
                <Button
                  type="text"
                  icon={<ArrowLeftOutlined />}
                  onClick={() => navigate("/patient-list")}
                  className="text-white hover:text-gray-300 flex items-center gap-2"
                >
                  Back to Patients
                </Button>
                <div className="flex gap-2">
                      <Button
                    id="button-send-survey-request"
                    type="primary"
                    disabled={isSurveyRequested}
                    onClick={handleCopyLink}
                    className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 border-none px-4 py-2 h-auto text-white font-medium rounded-xl shadow-lg transition-all duration-200 transform hover:scale-105"
                    icon={<CalendarIcon />}
                    
                  >
                    {t("request_survey")}
                  </Button>
                  <Button
                    type="primary"
                    icon={<EditOutlined />}
                    onClick={() => patientInfoRef.current?.showEditModal()}
                    className="bg-gray-600 border-gray-600 hover:bg-gray-500 text-white rounded-lg px-4 py-2 h-auto font-medium flex items-center gap-2"
                  >
                    <span className="hidden sm:inline">Edit Patient</span>
                  </Button>
                  <Button
                    type="primary"
                    icon={<DeleteOutlined />}
                    onClick={() => patientInfoRef.current?.showDeleteModal()}
                    className="bg-red-700 border-red-700 hover:bg-red-600 text-white rounded-lg px-4 py-2 h-auto font-medium flex items-center gap-2"
                  >
                    <span className="hidden sm:inline">Delete Patient</span>
                  </Button>
                
                </div>
              </div>

              <PatientInfoHeader
                ref={patientInfoRef}
                patient={patient}
                date={visits[0]?.date}
                onUpdate={fetchPatient}
              />
            </div>
          )}
          <WrinklesBanner />
        </div>
        <div className="mt-2 bg-[--accent-primary] rounded-xl shadow-sm p-6 border border-[--accent-secondary]">
          <h2 className="text-lg font-semibold mb-4">
            {t("data_registration")}
          </h2>
          <PatientTreatmentSteps patientId={patientId} />
        </div>
        <ReportTable />
        <VisitsHistory visits={visits} onUpdate={setVisits} />
      </DashboardWrapper>
    );
};

export default PatientsCabinetPage;
